import {
  AuditClient,
  BrowserCallClient,
  PayorClient,
  UserClient,
  OrganizationClient,
  InvitationClient,
  PatientClient,
  ProviderClient,
  LocationClient,
  InteractionClient,
  TaskClient,
  TaskOverviewClient,
  TeamClient,
  AgentClient,
  AppointmentClient,
  IntegrationClient,
  RoleClient,
  ClassificationLabelClient,
  EntityClient,
  DocumentClient,
  EmailClient,
  TaskAssignmentRuleClient,
  SearchClient,
  ScheduleBlockClient,
  WaitlistClient,
  AppointmentTypeClient,
  MedicalCodeClient,
  AppointmentTypeMatchingClient,
  ProviderSelectionClient,
  PlatformClient,
  UserPreferencesClient,
  DashboardClient,
  FeedbackClient,
  SmsTestClient,
  VoicePreviewClient,
  OutreachClient,
  AgentComponentsClient,
  WorkflowDefnsClient,
} from '@vagusx/clients';
import { API_URL } from './env';

function createSingleton<T>(ClientClass: new (url: string) => T): () => T {
  let instance: T | null = null;
  return () => {
    if (!instance) {
      instance = new ClientClass(API_URL);
    }
    return instance;
  };
}

export const getUserClient = createSingleton(UserClient);
export const getOrganizationClient = createSingleton(OrganizationClient);
export const getInvitationClient = createSingleton(InvitationClient);
export const getPatientClient = createSingleton(PatientClient);
export const getProviderClient = createSingleton(ProviderClient);
export const getLocationClient = createSingleton(LocationClient);
export const getInteractionClient = createSingleton(InteractionClient);
export const getTaskClient = createSingleton(TaskClient);
export const getTaskOverviewClient = createSingleton(TaskOverviewClient);
export const getTeamClient = createSingleton(TeamClient);
export const getAgentClient = createSingleton(AgentClient);
export const getAppointmentClient = createSingleton(AppointmentClient);
export const getIntegrationClient = createSingleton(IntegrationClient);
export const getRoleClient = createSingleton(RoleClient);
export const getClassificationLabelClient = createSingleton(ClassificationLabelClient);
export const getEntityClient = createSingleton(EntityClient);
export const getDocumentClient = createSingleton(DocumentClient);
export const getEmailClient = createSingleton(EmailClient);
export const getTaskAssignmentRuleClient = createSingleton(TaskAssignmentRuleClient);
export const getSearchClient = createSingleton(SearchClient);
export const getScheduleBlockClient = createSingleton(ScheduleBlockClient);
export const getWaitlistClient = createSingleton(WaitlistClient);
export const getAppointmentTypeClient = createSingleton(AppointmentTypeClient);
export const getMedicalCodeClient = createSingleton(MedicalCodeClient);
export const getPayorClient = createSingleton(PayorClient);
export const getAuditClient = createSingleton(AuditClient);
export const getAppointmentTypeMatchingClient = createSingleton(AppointmentTypeMatchingClient);
export const getProviderSelectionClient = createSingleton(ProviderSelectionClient);
export const getPlatformClient = createSingleton(PlatformClient);
export const getUserPreferencesClient = createSingleton(UserPreferencesClient);
export const getDashboardClient = createSingleton(DashboardClient);
export const getFeedbackClient = createSingleton(FeedbackClient);
export const getBrowserCallClient = createSingleton(BrowserCallClient);
export const getSmsTestClient = createSingleton(SmsTestClient);
export const getVoicePreviewClient = createSingleton(VoicePreviewClient);
export const getOutreachClient = createSingleton(OutreachClient);
export const getAgentComponentsClient = createSingleton(AgentComponentsClient);
export const getWorkflowDefnsClient = createSingleton(WorkflowDefnsClient);
